import { useState } from 'react';
import { useToast } from './shared';

export const UNIT_LABEL = { day: 'يوم', week: 'أسبوع', month: 'شهر', year: 'سنة' };
export const everyLabel = (v, u) => `كل ${v > 1 ? v + ' ' : ''}${UNIT_LABEL[u] || u}`;
export const todayStr = () => new Date().toLocaleDateString('en-CA');
export const RESULT = { ok: ['✓ تمام', 'badge-green'], issue: ['⚠ فيه مشكلة', 'badge-yellow'], not_done: ['✗ متعملتش', 'badge-gray'] };
export const VISIT_STATUS = {
  planned: ['مخططة', 'badge-blue'], partial: ['جزئية', 'badge-yellow'], done: ['تمت', 'badge-green'], missed: ['اتلغت', 'badge-gray'],
};
export function visitBadge(v) {
  if ((v.status === 'planned' || v.status === 'partial') && v.scheduled_date < todayStr()) return ['متأخرة', 'badge-red'];
  return VISIT_STATUS[v.status] || [v.status, 'badge-gray'];
}

// Log one device in a visit: due tasks checklist + result + notes
export function DeviceLogForm({ tasks, initial, onSubmit, onCancel, compact }) {
  const [checks, setChecks] = useState(() => {
    const prev = (initial && initial.checklist) || [];
    return tasks.map(t => ({ text: t.text, ok: !!(prev.find(p => p.text === t.text) || {}).ok }));
  });
  const [result, setResult] = useState((initial && initial.result) || 'ok');
  const [date, setDate] = useState((initial && initial.done_at) || todayStr());
  const [notes, setNotes] = useState((initial && initial.notes) || '');
  const [busy, setBusy] = useState(false);
  const toast = useToast();

  async function submit() {
    if (result === 'ok' && checks.some(c => !c.ok) && !window.confirm('مش كل الخطوات متعلّمة. تسجّلها "تمام" برضه؟')) return;
    setBusy(true);
    try { await onSubmit({ checklist: checks, result, done_at: date, notes }); }
    catch (e) { toast(e.message, 'error'); }
    finally { setBusy(false); }
  }

  return (
    <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed var(--border)' }}>
      {checks.map((c, i) => (
        <label key={i} className="flex items-center gap-8" style={{ padding: compact ? '6px 2px' : '10px 4px', borderBottom: '1px solid var(--border)', cursor: 'pointer', fontSize: compact ? 14 : 15 }}>
          <input type="checkbox" checked={c.ok} style={{ width: 22, height: 22, flexShrink: 0 }}
            onChange={() => setChecks(cs => cs.map((x, j) => (j === i ? { ...x, ok: !x.ok } : x)))} />
          <span style={{ textDecoration: c.ok ? 'line-through' : 'none', opacity: c.ok ? 0.6 : 1 }}>{c.text}</span>
        </label>
      ))}
      <div className="flex gap-8 mt-8" style={{ flexWrap: 'wrap' }}>
        {Object.entries(RESULT).map(([k, [l]]) => (
          <button key={k} className={`btn btn-sm ${result === k ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setResult(k)}>{l}</button>
        ))}
        <input className="input" type="date" style={{ width: 'auto', marginInlineStart: 'auto' }} value={date} onChange={e => setDate(e.target.value)} />
      </div>
      <textarea className="input mt-8" rows={2} value={notes} onChange={e => setNotes(e.target.value)}
        placeholder="اللي اتعمل، قطع اتغيرت، ملاحظات للمرة الجاية..." />
      <div className="flex gap-8 mt-8">
        <button className="btn btn-primary" style={{ flex: 1, padding: compact ? 8 : 12 }} disabled={busy} onClick={submit}>{busy ? '...' : 'حفظ'}</button>
        {onCancel && <button className="btn btn-ghost" onClick={onCancel}>إلغاء</button>}
      </div>
    </div>
  );
}
